/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { HiPencil, HiTrash } from 'react-icons/hi2' // Npm: React icons.
import {
  IconButton,
  Menu,
  MenuItem
} from '@mui/material' // Npm: Material UI components.


/*
 * OBJECTS
 */
const Index = ({
  phoneNumberReplacementServiceId,
  phoneNumberReplacementServiceIds,
  onPhoneNumberReplacementServiceUpdate,
  onPhoneNumberReplacementServiceDelete,
  PassOnUpdate,
  selectedIds
}) => {
  // Hook assignment.
  const [_anchorEl, _setAnchorEl] = React.useState(null)
  const _open = Boolean(_anchorEl)

  const _handleClick = event => {
    _setAnchorEl(event.currentTarget)
  }

  const _handleClose = () => {
    _setAnchorEl(null)
  }

  // Return Component.
  return (
    <>
      <IconButton onClick={_handleClick}>
        <HiPencil size={18} />
      </IconButton>
      <Menu
        anchorEl={_anchorEl}
        open={_open}
        onClose={_handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuItem
          onClick={() => {
            // Update state.
            PassOnUpdate({ phoneNumberReplacementServiceIds, phoneNumberReplacementServiceId })

            // Execute handler.
            onPhoneNumberReplacementServiceUpdate(selectedIds)

            _handleClose()
          }}
        >
          <HiPencil size={18} />
          <span>Edit Phone Number Replacement Service</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Update state.
            PassOnUpdate({ phoneNumberReplacementServiceIds, phoneNumberReplacementServiceId })

            // Execute handler.
            onPhoneNumberReplacementServiceDelete(selectedIds)

            _handleClose()
          }}
        >
          <HiTrash size={18} />
          <span>Delete Phone Number Replacement Service</span>
        </MenuItem>
      </Menu>
    </>
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'phoneNumberReplacementServiceId': PropTypes.string,
  'phoneNumberReplacementServiceIds': PropTypes.array,
  'onPhoneNumberReplacementServiceUpdate': PropTypes.func,
  'onPhoneNumberReplacementServiceDelete': PropTypes.func,
  'PassOnUpdate': PropTypes.func,
  'selectedIds': PropTypes.array
}


/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u })
})


/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
